import { MASS_ACTIONS, BULK_ACTIONS } from 'constants/actionTypes';
import request from 'utils/request_ajax';
import { ui, routes, MASS_ACTION } from 'constants/config';
import { selectedItemsSelector } from '../../../selectors';
import { bulkActionsRequest } from './bulk_core';
import { dataFetch } from './data';

const massActionsSuccess = (updatedShared, name) => dispatch => {
  dispatch({ type: MASS_ACTIONS.SHARED.UPDATED, updatedShared });
  dispatch({ type: BULK_ACTIONS.SUBMIT.SUCCESS });

  setTimeout(() => {
    dispatch({ type: BULK_ACTIONS.MASS_ACTION.DONE });
    dispatch({ type: MASS_ACTIONS.SHARED.REMOVE_ALL });
    if (name === MASS_ACTION.MASS_TAGGING) {
      dispatch(dataFetch(true));
    }
  }, ui.NOTIFICATION_SUCCESS_DELAY);
};

const requestShared =
  ({ route, requestedResource }) =>
  (dispatch, getState) => {
    dispatch({ type: MASS_ACTIONS.SHARED.REQUEST });

    request
      .postJSON(route, {
        contents: selectedItemsSelector(getState()),
      })
      .then(payload =>
        dispatch({
          type: MASS_ACTIONS.SHARED.REQUEST_SUCCESS,
          shared: payload[requestedResource],
        }),
      );
  };

const massActionsApply =
  ({ name, route, data, updatedShared }) =>
  (dispatch, getState) => {
    const { bulk } = getState();

    if (!bulk.inProgress) {
      dispatch(bulkActionsRequest(name));

      request
        .postJSON(route, {
          contents: selectedItemsSelector(getState()),
          ...data,
        })
        .done(() => dispatch(massActionsSuccess(updatedShared, name)))
        .fail(() => dispatch({ type: BULK_ACTIONS.SUBMIT.FAILURE }));
    }
  };

export const applyTags = tags => dispatch =>
  dispatch(
    massActionsApply({
      name: MASS_ACTION.MASS_TAGGING,
      route: routes.LEARN_UPDATE_TAGS,
      data: { tags: tags.map(tag => tag.id) },
      updatedShared: tags,
    }),
  );

export const requestSharedtags = () => dispatch =>
  dispatch(
    requestShared({
      route: routes.LEARN_SHARED_TAGS_FOR_CONTENTS,
      requestedResource: 'tags',
    }),
  );

export const applyGroups = groups => dispatch =>
  dispatch(
    massActionsApply({
      name: MASS_ACTION.MASS_LEARN,
      route: routes.LEARN_UPDATE_LIBRARY_CONTENTS,
      data: { groups: groups.map(group => group.id) },
      updatedShared: groups,
    }),
  );

export const requestSharedGroups = () => dispatch =>
  dispatch(
    requestShared({
      route: routes.LEARN_SHARED_LIBRARY_GROUPS_FOR_CONTENTS,
      requestedResource: 'groups',
    }),
  );

export const applyOwners = owners => dispatch =>
  dispatch(
    massActionsApply({
      name: MASS_ACTION.MASS_OWNERSHIP,
      route: routes.LEARN_UPDATE_OWNERS,
      data: { owners: owners.map(owner => owner.id) },
      updatedShared: owners,
    }),
  );

export const requestSharedOwners = () => dispatch =>
  dispatch(
    requestShared({
      route: routes.LEARN_SHARED_OWNERS_FOR_CONTENTS,
      requestedResource: 'owners',
    }),
  );
